/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Check if two routeProps are equal by checking if the location object is the same.
 */

import { RouteComponentProps } from 'react-router-dom'

import { MaybeRouteProps } from '../types'

import { locationsEqual } from './locationsEqual'
import { matchesEqual } from './matchesEqual'

export const routePropsEqual = (
  routeProps?: MaybeRouteProps | RouteComponentProps,
  prevRouteProps?: MaybeRouteProps | RouteComponentProps
) => {
  if (routeProps === prevRouteProps || (!routeProps && !prevRouteProps)) {
    return true
  }
  if (!routeProps || !prevRouteProps) {
    return false
  }
  const { location, match } = routeProps
  const { location: prevLocation, match: prevMatch } = prevRouteProps
  return (
    locationsEqual(location, prevLocation) && matchesEqual(match, prevMatch)
  )
}
